function required(message) {
    return (value) => {
        if (!value) {
            throw new Error(message);
        }
    };
}
export default required;
